import { routes as menu } from "./views/menu"
import { routes as notfound } from "./views/notfound";


export const routes = [    
    ...menu,

    ...notfound
];